import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { MessageCircle, Clapperboard } from "lucide-react";
import Logo from "@/components/Logo";
import TikTokIcon from "@/components/TikTokIcon";
import { fadeUp } from "@/lib/motion";
import { WHATSAPP_URL, WHATSAPP_DISPLAY, TIKTOK_URL, TIKTOK_HANDLE } from "@/lib/filters";

export default function Footer() {
    return (
        <footer id="contact" className="border-t border-white/10">
            <section className="py-20 sm:py-28">
                <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
                    <motion.div {...fadeUp} className="mx-auto max-w-3xl text-center">
                        <h2 className="font-display text-4xl font-black tracking-tight sm:text-6xl">
                            Want a custom grade? <span className="text-amberx">Let&apos;s talk.</span>
                        </h2>
                        <p className="mt-5 text-base leading-relaxed text-slate-400 sm:text-lg">
                            The editor above is free forever. For branded looks, weddings, events or
                            anything bigger — message the studio.
                        </p>
                        <div className="mt-8 flex flex-col items-center gap-4">
                            <a
                                href={WHATSAPP_URL}
                                target="_blank"
                                rel="noreferrer"
                                data-testid="contact-whatsapp-link"
                                className="inline-flex h-14 items-center gap-3 rounded-full bg-amberx px-8 font-display text-base font-bold text-obsidian shadow-[0_0_40px_rgba(255,159,28,0.3)] transition-transform hover:scale-[1.03] active:scale-95"
                            >
                                <MessageCircle className="h-5 w-5" />
                                Chat on WhatsApp
                            </a>
                            <span className="font-mono text-xs tracking-[0.2em] text-slate-500">
                                {WHATSAPP_DISPLAY}
                            </span>
                            <a
                                href={TIKTOK_URL}
                                target="_blank"
                                rel="noreferrer"
                                data-testid="contact-tiktok-link"
                                className="inline-flex items-center gap-2 text-sm font-semibold text-slate-300 transition-colors hover:text-amberx"
                            >
                                <TikTokIcon className="h-4 w-4" />
                                Watch our edits — {TIKTOK_HANDLE} on TikTok
                            </a>
                        </div>
                    </motion.div>
                </div>
            </section>

            <div className="border-t border-white/10 bg-surface/50">
                <div className="mx-auto flex max-w-7xl flex-col items-center justify-between gap-6 px-4 py-10 sm:px-6 md:flex-row lg:px-8">
                    <Logo />
                    <p className="text-sm text-slate-500">Mobile video editing, right in your browser.</p>
                    <div className="flex items-center gap-5">
                        <Link to="/editor" className="inline-flex items-center gap-2 text-sm font-semibold text-slate-300 transition-colors hover:text-amberx">
                            <Clapperboard className="h-4 w-4" />
                            Editor
                        </Link>
                        <a
                            href={TIKTOK_URL}
                            target="_blank"
                            rel="noreferrer"
                            data-testid="footer-tiktok-link"
                            className="text-sm font-semibold text-slate-300 transition-colors hover:text-amberx"
                        >
                            TikTok
                        </a>
                        <a
                            href={WHATSAPP_URL}
                            target="_blank"
                            rel="noreferrer"
                            className="text-sm font-semibold text-slate-300 transition-colors hover:text-amberx"
                        >
                            WhatsApp
                        </a>
                        <span className="font-mono text-xs text-slate-600">
                            © {new Date().getFullYear()} Deoeditz
                        </span>
                    </div>
                </div>
            </div>
        </footer>
    );
}
